import { Icons as e } from "../Icons/Icons.mjs";
import { Flex as t } from "../Primitives/Flex.mjs";
import "react";
import { useTheme as n } from "styled-components";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/StarRating/StarRating.tsx
var a = ({ rating: a, maxStars: o = 5, size: s = 20, color: c, emptyColor: l, gap: u = 1, className: d }) => {
	let f = n(), p = (e, t) => e ? f?.colors && e in f.colors ? f.colors[e] : e : t, m = p(c, "#FFB800"), h = p(l, f?.colors?.muted || "#E2E8F0"), g = Math.max(0, Math.min(a, o));
	return /* @__PURE__ */ r(t, {
		gap: u,
		align: "center",
		className: d,
		inline: !0,
		children: Array.from({ length: o }, (t, n) => {
			let a = n + 1, o = g >= a, c = !o && g > a - 1;
			return o ? /* @__PURE__ */ r(e.Star, {
				size: s,
				color: m,
				fill: m,
				strokeWidth: 0
			}, n) : c ? /* @__PURE__ */ i("div", {
				style: {
					position: "relative",
					display: "inline-flex",
					width: s,
					height: s
				},
				children: [/* @__PURE__ */ r(e.Star, {
					size: s,
					color: h,
					fill: h,
					strokeWidth: 0
				}), /* @__PURE__ */ r("div", {
					style: {
						position: "absolute",
						top: 0,
						left: 0
					},
					children: /* @__PURE__ */ r(e.StarHalf, {
						size: s,
						color: m,
						fill: m,
						strokeWidth: 0
					})
				})]
			}, n) : /* @__PURE__ */ r(e.Star, {
				size: s,
				color: h,
				fill: h,
				strokeWidth: 0
			}, n);
		})
	});
};
a.displayName = "StarRating";
//#endregion
export { a as StarRating };
